import { IbcTankTypeEnum } from 'src/enums/stowage/IbcTankTypeEnum';
import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const incompatibleIbcTankTypeHardRule: StowageRuleBM = {
    id: StowageRuleId.IncompatibleIbcTankTypeHardRule,
    name: 'A cargo cannot be stowed in a tank with an incompatible IBC tank type.',
    lastUpdatedUtc: '2024-07-26T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Cargo property product.category.isAnnexIIChapter17',
                            fieldPath: 'cargo.product.category.isAnnexIIChapter17',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
            {
                operator: BooleanOperator.OR,
                children: [
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Cargo property product.category.tankType',
                                    fieldPath: 'cargo.product.category.tankType',
                                    type: 'number',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'number',
                                    referenceValue: IbcTankTypeEnum.Unknown.toString(),
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Equals,
                        },
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.tankType',
                                            fieldPath: 'cargo.product.category.tankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type1G.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.ibcTankType',
                                            fieldPath: 'tank.ibcTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type1G.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                                },
                            },
                        ],
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.tankType',
                                            fieldPath: 'cargo.product.category.tankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type1P.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.ibcTankType',
                                            fieldPath: 'tank.ibcTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type1P.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                                },
                            },
                        ],
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.tankType',
                                            fieldPath: 'cargo.product.category.tankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type2G.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.ibcTankType',
                                            fieldPath: 'tank.ibcTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type1G.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.ibcTankType',
                                            fieldPath: 'tank.ibcTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type2G.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                                },
                            },
                        ],
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.tankType',
                                            fieldPath: 'cargo.product.category.tankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type2P.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.ibcTankType',
                                            fieldPath: 'tank.ibcTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type1P.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.ibcTankType',
                                            fieldPath: 'tank.ibcTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcTankTypeEnum.Type2P.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.IsNotEqualTo,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Incompatible IBC tank type',
    },
};
